import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, toHandlers as _toHandlers, mergeProps as _mergeProps, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col-lg-8" }
const _hoisted_6 = { class: "inline-items" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fa fa-bookmark fa-w-12 mr-1 text-warning" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Edit Project Estimation")
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fa fa-bookmark fa-w-12 mr-1 text-warning" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Create Project Estimation")
const _hoisted_13 = { class: "breadcrumb-wrap mt-1" }
const _hoisted_14 = { "aria-label": "breadcrumb" }
const _hoisted_15 = { class: "breadcrumb mb-0" }
const _hoisted_16 = /*#__PURE__*/_createVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createVNode("a", { href: "#" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-home mr-2" }),
    /*#__PURE__*/_createTextVNode(" Home ")
  ])
], -1)
const _hoisted_17 = { class: "breadcrumb-item" }
const _hoisted_18 = /*#__PURE__*/_createVNode("li", {
  class: "breadcrumb-item active",
  "aria-current": "page"
}, "Estimation", -1)
const _hoisted_19 = { class: "col-lg-4" }
const _hoisted_20 = { class: "text-lg-right" }
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "fa fa-chevron-left mr-2" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Go Back ")
const _hoisted_23 = { class: "card" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = /*#__PURE__*/_createVNode("label", { for: "" }, "Customer Emails", -1)
const _hoisted_26 = { class: "text-red" }
const _hoisted_27 = { class: "bg-light p-2 rounded border mb-3" }
const _hoisted_28 = {
  key: 0,
  class: "row mx-n2"
}
const _hoisted_29 = {
  key: 0,
  class: "shadowed-card bg-white h-100 p-2"
}
const _hoisted_30 = { class: "text-end" }
const _hoisted_31 = /*#__PURE__*/_createVNode("i", { class: "fa fa-check-circle" }, null, -1)
const _hoisted_32 = { class: "row mx-n2" }
const _hoisted_33 = { class: "col-xl-6 px-2" }
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = /*#__PURE__*/_createVNode("label", { for: "" }, [
  /*#__PURE__*/_createVNode("small", null, "Enter Email Address")
], -1)
const _hoisted_36 = { class: "text-red" }
const _hoisted_37 = { class: "col-xl-6 px-2" }
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = /*#__PURE__*/_createVNode("label", { for: "First Name" }, [
  /*#__PURE__*/_createVNode("small", null, "First Name")
], -1)
const _hoisted_40 = { class: "col-xl-6 px-2" }
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = /*#__PURE__*/_createVNode("label", { for: "Middle Name" }, [
  /*#__PURE__*/_createVNode("small", null, "Middle Name")
], -1)
const _hoisted_43 = { class: "col-xl-6 px-2" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = /*#__PURE__*/_createVNode("label", { for: "Last Name" }, [
  /*#__PURE__*/_createVNode("small", null, "Last Name")
], -1)
const _hoisted_46 = { class: "col-xl-6 px-2" }
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = /*#__PURE__*/_createVNode("label", { for: "Phone" }, [
  /*#__PURE__*/_createVNode("small", null, "Phone Number")
], -1)
const _hoisted_49 = { class: "text-red" }
const _hoisted_50 = { class: "col-xl-6 px-2" }
const _hoisted_51 = { class: "form-group" }
const _hoisted_52 = /*#__PURE__*/_createVNode("label", { for: "address" }, [
  /*#__PURE__*/_createVNode("small", null, "Address")
], -1)
const _hoisted_53 = {
  key: 1,
  class: "shadowed-card bg-white h-100 p-2"
}
const _hoisted_54 = { class: "text-end" }
const _hoisted_55 = /*#__PURE__*/_createVNode("i", { class: "fa fa-pencil-alt" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt" }, null, -1)
const _hoisted_57 = { class: "row mx-n2" }
const _hoisted_58 = { class: "col-xl-6 px-2" }
const _hoisted_59 = { class: "mb-3" }
const _hoisted_60 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("small", null, [
    /*#__PURE__*/_createVNode("strong", null, "Enter Email Address")
  ])
], -1)
const _hoisted_61 = { class: "col-xl-6 px-2" }
const _hoisted_62 = { class: "mb-3" }
const _hoisted_63 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("small", null, [
    /*#__PURE__*/_createVNode("strong", null, "First Name")
  ])
], -1)
const _hoisted_64 = { class: "col-xl-6 px-2" }
const _hoisted_65 = { class: "mb-3" }
const _hoisted_66 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("small", null, [
    /*#__PURE__*/_createVNode("strong", null, "Middle Name")
  ])
], -1)
const _hoisted_67 = { class: "col-xl-6 px-2" }
const _hoisted_68 = { class: "mb-3" }
const _hoisted_69 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("small", null, [
    /*#__PURE__*/_createVNode("strong", null, "last Name")
  ])
], -1)
const _hoisted_70 = { class: "col-xl-6 px-2" }
const _hoisted_71 = { class: "mb-3" }
const _hoisted_72 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("small", null, [
    /*#__PURE__*/_createVNode("strong", null, "Phone Number")
  ])
], -1)
const _hoisted_73 = { class: "col-xl-6 px-2" }
const _hoisted_74 = { class: "mb-3" }
const _hoisted_75 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("small", null, [
    /*#__PURE__*/_createVNode("strong", null, "Address")
  ])
], -1)
const _hoisted_76 = {
  key: 1,
  class: "alert alert-warning text-center",
  role: "alert"
}
const _hoisted_77 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle me-1" }, null, -1)
const _hoisted_78 = /*#__PURE__*/_createTextVNode(" Customer has not been selected. Please select or add customer email. ")
const _hoisted_79 = { class: "row" }
const _hoisted_80 = { class: "col-md-6" }
const _hoisted_81 = { class: "form-group" }
const _hoisted_82 = /*#__PURE__*/_createVNode("label", { for: "" }, "Name", -1)
const _hoisted_83 = { class: "form-group" }
const _hoisted_84 = /*#__PURE__*/_createVNode("label", { for: "" }, "Estimation $", -1)
const _hoisted_85 = { class: "col-md-6" }
const _hoisted_86 = { class: "form-group" }
const _hoisted_87 = /*#__PURE__*/_createVNode("label", { for: "" }, "Details", -1)
const _hoisted_88 = { class: "row" }
const _hoisted_89 = { class: "col-md-6" }
const _hoisted_90 = { class: "form-group" }
const _hoisted_91 = /*#__PURE__*/_createVNode("label", { for: "" }, "Start Date", -1)
const _hoisted_92 = { class: "col-md-6" }
const _hoisted_93 = { class: "form-group" }
const _hoisted_94 = /*#__PURE__*/_createVNode("label", { for: "" }, "End Date", -1)
const _hoisted_95 = { class: "form-group" }
const _hoisted_96 = /*#__PURE__*/_createVNode("label", { for: "" }, "Attachements (Docs)", -1)
const _hoisted_97 = {
  key: 0,
  class: "image-in-chat preview-image-list"
}
const _hoisted_98 = { class: "row mx-n2" }
const _hoisted_99 = {
  key: 0,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_100 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_101 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_102 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_103 = { class: "imaged-col" }
const _hoisted_104 = { class: "small-img-wrap" }
const _hoisted_105 = {
  key: 1,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_106 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_107 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_108 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_109 = { class: "imaged-col" }
const _hoisted_110 = { class: "small-img-wrap" }
const _hoisted_111 = {
  key: 2,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_112 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_113 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_114 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_115 = { class: "imaged-col" }
const _hoisted_116 = /*#__PURE__*/_createVNode("div", { class: "small-img-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-word" })
], -1)
const _hoisted_117 = {
  key: 3,
  class: "media-wrap shadowed-card bg-white mb-2"
}
const _hoisted_118 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_119 = /*#__PURE__*/_createVNode("div", { class: "centered-wrap" }, [
  /*#__PURE__*/_createVNode("span", {
    class: "spinner-border big-spinner",
    role: "status"
  }, [
    /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
  ])
], -1)
const _hoisted_120 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_121 = {
  key: 0,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_122 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_123 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_124 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_125 = { class: "imaged-col" }
const _hoisted_126 = { class: "small-img-wrap" }
const _hoisted_127 = { class: "size" }
const _hoisted_128 = {
  key: 1,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_129 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_130 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_131 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_132 = { class: "imaged-col" }
const _hoisted_133 = { class: "small-img-wrap" }
const _hoisted_134 = { class: "size" }
const _hoisted_135 = {
  key: 2,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_136 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_137 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_138 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_139 = { class: "imaged-col" }
const _hoisted_140 = /*#__PURE__*/_createVNode("div", { class: "small-img-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-word" })
], -1)
const _hoisted_141 = { class: "size" }
const _hoisted_142 = {
  key: 3,
  class: "media-wrap shadowed-card bg-white mb-2"
}
const _hoisted_143 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_144 = /*#__PURE__*/_createVNode("div", { class: "centered-wrap" }, [
  /*#__PURE__*/_createVNode("span", {
    class: "spinner-border big-spinner",
    role: "status"
  }, [
    /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
  ])
], -1)
const _hoisted_145 = { class: "size" }
const _hoisted_146 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_147 = /*#__PURE__*/_createVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createVNode("p", null, "OR")
], -1)
const _hoisted_148 = { class: "form-group" }
const _hoisted_149 = /*#__PURE__*/_createVNode("label", { for: "" }, "Edoc Link", -1)
const _hoisted_150 = { class: "form-group" }
const _hoisted_151 = { class: "modal-wrap default-modal" }
const _hoisted_152 = {
  class: "modal fade",
  id: "deleteModal",
  tabindex: -1,
  "aria-labelledby": "showPojectLabel",
  "aria-hidden": "true"
}
const _hoisted_153 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_154 = { class: "modal-content" }
const _hoisted_155 = { class: "modal-header" }
const _hoisted_156 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "showPojectLabel"
}, " Remove ", -1)
const _hoisted_157 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_158 = /*#__PURE__*/_createVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "alert alert-danger mb-0",
    role: "alert"
  }, " Are you sure you want to remove? ")
], -1)
const _hoisted_159 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_big = _resolveComponent("big")
  const _component_router_link = _resolveComponent("router-link")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_multiselect = _resolveComponent("multiselect")
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_DragAndDropZone = _resolveComponent("DragAndDropZone")
  const _component_Button = _resolveComponent("Button")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.state.ui.isPostLoading.createEstimation || _ctx.state.ui.isPostLoading.updateEstimation)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", null, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("ul", null, [
                (_ctx.state.ui.isLoading.isEdit)
                  ? (_openBlock(), _createBlock("li", _hoisted_7, [
                      _createVNode("strong", null, [
                        _hoisted_8,
                        _createVNode(_component_big, null, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : (_openBlock(), _createBlock("li", _hoisted_10, [
                      _createVNode("strong", null, [
                        _hoisted_11,
                        _createVNode(_component_big, null, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        })
                      ])
                    ]))
              ])
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode("nav", _hoisted_14, [
                _createVNode("ol", _hoisted_15, [
                  _hoisted_16,
                  _createVNode("li", _hoisted_17, [
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToProjectDetails && _ctx.redirectToProjectDetails(...args)))
                    }, _toDisplayString(_ctx.state.data.projectEstimations.name), 1)
                  ]),
                  _hoisted_18
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_19, [
            _createVNode("div", _hoisted_20, [
              _createVNode(_component_router_link, {
                class: "btn default-btn outline d-inline-block",
                to: {
              name: 'admin-project-details',
              params: { projectId: _ctx.state.projectId },
            }
              }, {
                default: _withCtx(() => [
                  _hoisted_21,
                  _hoisted_22
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_23, [
        _createVNode(_component_ErrorList, {
          errors: _ctx.state.ui.errors.errorList.approval,
          hasError: _ctx.state.ui.errors.hasError
        }, null, 8, ["errors", "hasError"]),
        _createVNode("form", null, [
          _createVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode(_component_multiselect, {
              modelValue: _ctx.state.data.selectedCustomers,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.selectedCustomers = $event)),
              "tag-placeholder": "Select or add customer email",
              placeholder: "Select or add customer email",
              label: "code",
              "track-by": "code",
              options: _ctx.state.data.allCustomer,
              multiple: true,
              taggable: true,
              onTag: _ctx.addCustomerEmail,
              onSelect: _ctx.changeValue
            }, null, 8, ["modelValue", "options", "onTag", "onSelect"]),
            _withDirectives(_createVNode("p", _hoisted_26, "please add valid/not owner email only", 512), [
              [_vShow, _ctx.isInvalid]
            ])
          ]),
          _createVNode("div", _hoisted_27, [
            (_ctx.state.data.selectedCustomers.length)
              ? (_openBlock(), _createBlock("div", _hoisted_28, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.selectedCustomers, (customer, customerIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "col-md-4 col-sm-6 mb-2 px-2",
                      key: customerIndex
                    }, [
                      (customer.isEdit)
                        ? (_openBlock(), _createBlock("div", _hoisted_29, [
                            _createVNode("div", _hoisted_30, [
                              _createVNode("a", {
                                class: "btn default-btn btn-sm",
                                title: "Update",
                                href: "javascript:void(\n                      0)",
                                onClick: ($event: any) => (_ctx.updateSelectCustomer(customerIndex))
                              }, [
                                _hoisted_31
                              ], 8, ["onClick"])
                            ]),
                            _createVNode("div", _hoisted_32, [
                              _createVNode("div", _hoisted_33, [
                                _createVNode("div", _hoisted_34, [
                                  _hoisted_35,
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    class: customer.emailError ? 'form-control error-field' : 'form-control',
                                    "onUpdate:modelValue": ($event: any) => (customer.email = $event)
                                  }, null, 10, ["onUpdate:modelValue"]), [
                                    [_vModelText, customer.email]
                                  ]),
                                  _createVNode("p", _hoisted_36, _toDisplayString(customer.emailError), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_37, [
                                _createVNode("div", _hoisted_38, [
                                  _hoisted_39,
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": ($event: any) => (customer.first_name = $event)
                                  }, null, 8, ["onUpdate:modelValue"]), [
                                    [_vModelText, customer.first_name]
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_40, [
                                _createVNode("div", _hoisted_41, [
                                  _hoisted_42,
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": ($event: any) => (customer.middle_name = $event)
                                  }, null, 8, ["onUpdate:modelValue"]), [
                                    [_vModelText, customer.middle_name]
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_43, [
                                _createVNode("div", _hoisted_44, [
                                  _hoisted_45,
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": ($event: any) => (customer.last_name = $event)
                                  }, null, 8, ["onUpdate:modelValue"]), [
                                    [_vModelText, customer.last_name]
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_46, [
                                _createVNode("div", _hoisted_47, [
                                  _hoisted_48,
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => (customer.phone = $event),
                                    class: customer.phoneError ? 'form-control error-field' : 'form-control'
                                  }, null, 10, ["onUpdate:modelValue"]), [
                                    [_vModelText, customer.phone]
                                  ]),
                                  _createVNode("p", _hoisted_49, _toDisplayString(customer.phoneError), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_50, [
                                _createVNode("div", _hoisted_51, [
                                  _hoisted_52,
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": ($event: any) => (customer.address_line1 = $event)
                                  }, null, 8, ["onUpdate:modelValue"]), [
                                    [_vModelText, customer.address_line1]
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_53, [
                            _createVNode("div", _hoisted_54, [
                              _createVNode("a", {
                                class: "btn default-btn btn-sm mr-2",
                                title: "Edit",
                                href: "javascript:void(\n                      0)",
                                onClick: ($event: any) => (_ctx.editSelectCustomer(customerIndex))
                              }, [
                                _hoisted_55
                              ], 8, ["onClick"]),
                              _createVNode("a", {
                                class: "btn btn-sm red-btn",
                                title: "Delete",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.showDelete(customer))
                              }, [
                                _hoisted_56
                              ], 8, ["onClick"])
                            ]),
                            _createVNode("div", _hoisted_57, [
                              _createVNode("div", _hoisted_58, [
                                _createVNode("div", _hoisted_59, [
                                  _hoisted_60,
                                  _createVNode("p", null, [
                                    _createVNode("small", null, _toDisplayString(customer.email), 1)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_61, [
                                _createVNode("div", _hoisted_62, [
                                  _hoisted_63,
                                  _createVNode("p", null, [
                                    _createVNode("small", null, _toDisplayString(customer.first_name), 1)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_64, [
                                _createVNode("div", _hoisted_65, [
                                  _hoisted_66,
                                  _createVNode("p", null, [
                                    _createVNode("small", null, _toDisplayString(customer.middle_name), 1)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_67, [
                                _createVNode("div", _hoisted_68, [
                                  _hoisted_69,
                                  _createVNode("p", null, [
                                    _createVNode("small", null, _toDisplayString(customer.last_name), 1)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_70, [
                                _createVNode("div", _hoisted_71, [
                                  _hoisted_72,
                                  _createVNode("p", null, [
                                    _createVNode("small", null, _toDisplayString(customer.phone), 1)
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_73, [
                                _createVNode("div", _hoisted_74, [
                                  _hoisted_75,
                                  _createVNode("p", null, [
                                    _createVNode("small", null, _toDisplayString(customer.address_line1), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]))
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_76, [
                  _hoisted_77,
                  _hoisted_78
                ]))
          ]),
          _createVNode("div", _hoisted_79, [
            _createVNode("div", _hoisted_80, [
              _createVNode("div", _hoisted_81, [
                _hoisted_82,
                _withDirectives(_createVNode("input", {
                  disabled: "",
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.projectEstimations.name = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.projectEstimations.name]
                ])
              ]),
              _createVNode("div", _hoisted_83, [
                _hoisted_84,
                _withDirectives(_createVNode("input", {
                  type: "number",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.projectEstimations.estimatedBudget = $event)),
                  min: "1",
                  placeholder: "eg. 5321"
                }, null, 512), [
                  [_vModelText, _ctx.state.data.projectEstimations.estimatedBudget]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_85, [
              _createVNode("div", _hoisted_86, [
                _hoisted_87,
                _withDirectives(_createVNode("textarea", {
                  disabled: "",
                  class: "form-control",
                  rows: "6",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.projectEstimations.description = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.projectEstimations.description]
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_88, [
            _createVNode("div", _hoisted_89, [
              _createVNode("div", _hoisted_90, [
                _hoisted_91,
                _createVNode(_component_v_date_picker, {
                  modelValue: _ctx.state.data.projectEstimations.startDate,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.projectEstimations.startDate = $event)),
                  "min-date": _ctx.state.data.todayData
                }, {
                  default: _withCtx(({ inputValue, inputEvents }) => [
                    _createVNode("input", _mergeProps({
                      class: "form-control",
                      value: inputValue
                    }, _toHandlers(inputEvents), { placeholder: "Select Start Date" }), null, 16, ["value"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "min-date"])
              ])
            ]),
            _createVNode("div", _hoisted_92, [
              _createVNode("div", _hoisted_93, [
                _hoisted_94,
                _createVNode(_component_v_date_picker, {
                  modelValue: _ctx.state.data.projectEstimations.endDate,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.projectEstimations.endDate = $event)),
                  "min-date": _ctx.state.data.projectEstimations.startDate
                }, {
                  default: _withCtx(({ inputValue, inputEvents }) => [
                    _createVNode("input", _mergeProps({
                      class: "form-control",
                      value: inputValue
                    }, _toHandlers(inputEvents), {
                      placeholder: "Select End Date",
                      disabled: _ctx.state.ui.isLoading.enableEndDate
                    }), null, 16, ["value", "disabled"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "min-date"])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_95, [
            _hoisted_96,
            _createVNode(_component_DragAndDropZone, {
              onDrop: _withModifiers(_ctx.dropFiles, ["prevent"]),
              onDropFiles: _ctx.dropFiles
            }, null, 8, ["onDrop", "onDropFiles"]),
            (_ctx.state.data.projectEstimations.attachments &&
            _ctx.state.data.projectEstimations.attachments.length
          )
              ? (_openBlock(), _createBlock("div", _hoisted_97, [
                  _createVNode("div", _hoisted_98, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.projectEstimations.attachments, (image, imageIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "col-sm-6",
                        key: imageIndex
                      }, [
                        (image.file_type === 'jpg' ||
                  image.file_type === 'png' ||
                  image.file_type === 'jpeg' ||
                  image.file_type === 'gif'
                )
                          ? (_openBlock(), _createBlock("div", _hoisted_99, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_100, [
                                    _hoisted_101
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeUploadSelectedImage(image))
                              }, [
                                _hoisted_102
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_103, [
                                _createVNode("div", _hoisted_104, [
                                  _createVNode("img", {
                                    src: image.file_link,
                                    alt: "",
                                    height: "200"
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.file_name), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.file_type === 'pdf')
                          ? (_openBlock(), _createBlock("div", _hoisted_105, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_106, [
                                    _hoisted_107
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeUploadSelectedImage(image))
                              }, [
                                _hoisted_108
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_109, [
                                _createVNode("div", _hoisted_110, [
                                  _createVNode("img", {
                                    src: _ctx.state.data.imageBaseUrl
                        ? `${_ctx.state.data.imageBaseUrl}img/pdf.jpg`
                        : 'img/pdf.jpg'
                      ,
                                    alt: ""
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.file_name), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.file_type === 'doc' ||
                  image.file_type === 'docx'
                )
                          ? (_openBlock(), _createBlock("div", _hoisted_111, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_112, [
                                    _hoisted_113
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                              }, [
                                _hoisted_114
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_115, [
                                _hoisted_116,
                                _createVNode("h5", null, _toDisplayString(image.file_name), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.file_type === 'mp4' ||
                  image.file_type === 'mov' ||
                  image.file_type === 'MOV' ||
                  image.file_type === 'wmv' ||
                  image.file_type === 'webm' ||
                  image.file_type === 'ogg' ||
                  image.file_type === 'avi' ||
                  image.file_type === 'x-ms-wmv'
                )
                          ? (_openBlock(), _createBlock("div", _hoisted_117, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_118, [
                                    _hoisted_119
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("img", {
                                src: _ctx.state.data.imageBaseUrl
                    ? `${_ctx.state.data.imageBaseUrl}img/video-icon.png`
                    : 'img/video-icon.png'
                  ,
                                alt: "",
                                height: "200"
                              }, null, 8, ["src"]),
                              _createVNode("h5", null, _toDisplayString(image.file_name), 1),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeUploadSelectedImage(image))
                              }, [
                                _hoisted_120
                              ], 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.projectEstimations.attachments, (image, imageIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "col-sm-6",
                        key: imageIndex
                      }, [
                        (image.extension === 'jpg' ||
                  image.extension === 'png' ||
                  image.extension === 'jpeg' ||
                  image.extension === 'gif'
                )
                          ? (_openBlock(), _createBlock("div", _hoisted_121, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_122, [
                                    _hoisted_123
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                              }, [
                                _hoisted_124
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_125, [
                                _createVNode("div", _hoisted_126, [
                                  _createVNode("img", {
                                    src: image.file,
                                    alt: "",
                                    height: "200"
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.name), 1),
                                _createVNode("p", _hoisted_127, _toDisplayString(image.size), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.extension === 'pdf')
                          ? (_openBlock(), _createBlock("div", _hoisted_128, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_129, [
                                    _hoisted_130
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                              }, [
                                _hoisted_131
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_132, [
                                _createVNode("div", _hoisted_133, [
                                  _createVNode("img", {
                                    src: _ctx.state.data.imageBaseUrl
                        ? `${_ctx.state.data.imageBaseUrl}img/pdf.jpg`
                        : 'img/pdf.jpg'
                      ,
                                    alt: ""
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("h5", null, _toDisplayString(image.name), 1),
                                _createVNode("p", _hoisted_134, _toDisplayString(image.size), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.extension === 'doc' ||
                  image.extension === 'docx'
                )
                          ? (_openBlock(), _createBlock("div", _hoisted_135, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_136, [
                                    _hoisted_137
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                              }, [
                                _hoisted_138
                              ], 8, ["onClick"]),
                              _createVNode("div", _hoisted_139, [
                                _hoisted_140,
                                _createVNode("h5", null, _toDisplayString(image.name), 1),
                                _createVNode("p", _hoisted_141, _toDisplayString(image.size), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (image.extension === 'mp4' ||
                  image.extension === 'mov' ||
                  image.extension === 'MOV' ||
                  image.extension === 'wmv' ||
                  image.extension === 'webm' ||
                  image.extension === 'ogg' ||
                  image.extension === 'avi' ||
                  image.extension === 'x-ms-wmv'
                )
                          ? (_openBlock(), _createBlock("div", _hoisted_142, [
                              (image.isuploded)
                                ? (_openBlock(), _createBlock("div", _hoisted_143, [
                                    _hoisted_144
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("img", {
                                src: _ctx.state.data.imageBaseUrl
                    ? `${_ctx.state.data.imageBaseUrl}img/video-icon.png`
                    : 'img/video-icon.png'
                  ,
                                alt: "",
                                height: "200"
                              }, null, 8, ["src"]),
                              _createVNode("h5", null, _toDisplayString(image.name), 1),
                              _createVNode("p", _hoisted_145, _toDisplayString(image.size), 1),
                              _createVNode("a", {
                                class: "remove-btnn",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                              }, [
                                _hoisted_146
                              ], 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_147,
          _createVNode("div", _hoisted_148, [
            _hoisted_149,
            _withDirectives(_createVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.data.projectEstimations.edocLink = $event)),
              placeholder: "https://qa.convorally.com"
            }, null, 512), [
              [_vModelText, _ctx.state.data.projectEstimations.edocLink]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_150, [
          (_ctx.state.ui.isLoading.isEdit)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "btn default-btn mr-2",
                type: "submit",
                onClick: _ctx.updateEstimation
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.state.ui.isPostLoading.updateEstimation ? "loading..." : "Update Estimation"), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                class: "btn default-btn mr-2",
                type: "submit",
                onClick: _ctx.createEstimation
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.state.ui.isPostLoading.createEstimation ? "loading..." : "Save as Draft"), 1)
                ]),
                _: 1
              }, 8, ["onClick"])),
          _createVNode("button", {
            type: "button",
            class: "btn",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.redirectToProjectDetails && _ctx.redirectToProjectDetails(...args)))
          }, " Cancel ")
        ])
      ]),
      (_ctx.state.data.showSuccesCustomModal)
        ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
            key: 0,
            onClose: _ctx.closeSuccessCustomModal,
            showModal: _ctx.state.data.showSuccesCustomModal,
            titleMessage: _ctx.state.data.successFulMessage
          }, null, 8, ["onClose", "showModal", "titleMessage"]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_151, [
        _createVNode("div", _hoisted_152, [
          _createVNode("div", _hoisted_153, [
            _createVNode("div", _hoisted_154, [
              _createVNode("div", _hoisted_155, [
                _hoisted_156,
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.hideDelete && _ctx.hideDelete(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_157
                ])
              ]),
              _hoisted_158,
              _createVNode("div", _hoisted_159, [
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.removeSelectCustomer(_ctx.state.data.removeUser)))
                }, _toDisplayString(_ctx.state.ui.isPostLoading.delete ? "loading..." : "Yes"), 1),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.hideDelete && _ctx.hideDelete(...args)))
                }, " No ")
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}